
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/payments",
      function () {
        return require("private-next-pages/features/payments.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/payments"])
      });
    }
  